import { render, staticRenderFns } from "./CustomerDetailEdit.vue?vue&type=template&id=46dca1dc"
import script from "./CustomerDetailEdit.vue?vue&type=script&lang=js"
export * from "./CustomerDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailEdit.vue?vue&type=style&index=0&id=46dca1dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports